import { ContextMenuState } from "../../../../shared/cubiq-services";

export class BfxBlotterOpsIntContextMenuState extends ContextMenuState {
  public isTrader: boolean;
  public isSales: boolean;
  public isClient: boolean;
  public hasOperationsResubmit: boolean;
  public hasOperationsCancel: boolean;
  public hasOperationsClear: boolean;

  public cancelOrderIneligible = false;
  public resendIneligible = false;
  public rePriceIneligible = false;
  public isClearIneligible = false;

  constructor() {
    super();
  }

  public reset(): void {
    this.cancelOrderIneligible = false;
    this.resendIneligible = false;
    this.rePriceIneligible = false;
    this.isClearIneligible = false;
    super.reset();
  }
}
